require('angular')
require('angular-route')
require('../../core/translation/translation-module')
require('../components/auth/auth-module')
require('../components/account/account-module')
require('../components/common-wrapper/common-wrapper-module')
require('../components/error-handler/error-handler-module')
require('../components/form/form-module.coffee')
require('./contact.jade')
ContactSuccessCtrl = require('./modals/contact-success-controller.coffee')
# Load Css
require('../../../sass/web/html/_contact_form.scss')

ContactCtrl = require('./contact-controller')
ContactService = require('./contact-service')

modules = [
  'ngRoute'
  'gnp-translation'
  'gnp-auth'
  'gnp-common-wrapper'
  'gnp-form'
  'gnp-error-handler'
  'gnp-account'
]
angular.module 'gnp-app-contact', modules
  .config ['$routeProvider', ($routeProvider) ->
    $routeProvider.when '/contact',
      templateUrl: 'web/contact/contact.jade'
      controller: 'ContactCtrl'
      resolve:
        userInfo: ['AuthService', 'AccountService', (AuthService, AccountService) ->
          AccountService.getUserInfo() if AuthService.isSignedIn()
        ]
      title: '_CONTACT.TITLE'
  ]
  .config ['$translateProvider', ($translateProvider) ->
    $translateProvider
      .translations 'en', require('./i18n/en')
      .translations 'ja', require('./i18n/ja')
  ]
  .controller 'ContactCtrl', ContactCtrl
  .controller 'ContactSuccessCtrl', ContactSuccessCtrl
  .factory 'ContactService', ContactService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/contact/contact-module.coffee